export class UniqueModel {
    monthToDate: number;
    today: number;
    yearToDate: number;
}


// WEBPACK FOOTER //
// ./src/app/dashboard/uniques/unique.model.ts